import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import socket from "../../../context/socket";
import axios from "axios";
import PortfolioDetails from "./PortfolioDetails";
import InvestmentsTable from "./InvestmentsTable";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import api from "../../../utils/api";

export const CentredVar = ({ isDarkMode }) => {
  const navigate = useNavigate();
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const [subNavRoute, setSubNavRoute] = useState();
  const [dataStatus, setDataStatus] = useState({ status: "idle", message: "" });


  const [hasHouseHold, setHasHouseHold] = useState(false);

  const [portfolioAsset, setPortfolioAsset] = useState([]);
  const [schemeType, setSchemeType] = useState([]);
  const [isStatesData, setIsStatesData] = useState({});
  const [users, setUsers] = useState([]);


  const [isEquityDiv, setIsEquityDiv] = useState({});
  const [isSIFDiv, setIsSIFDiv] = useState({});
  const [isHybridDiv, setIsHybridDiv] = useState({});
  const [isOtherDiv, setIsOtherDiv] = useState({});

  const [isDebtDiv, setIsDebtDiv] = useState({});


  const [indexedPortfolio, setIsIndexedPortfolio] = useState({});

  const [isEquityportfolioData, setIsEquityportfolioData] = useState({});
  const [isHybridportfolioData, setIsHybridportfolioData] = useState({});
  const [isDebtDivportfolioData, setIsDebtDivportfolioData] = useState({});


  const [activeTab, setActiveTab] = useState("livePortfolio"); // Track the active tab
  const [isLoading, setIsLoading] = useState(false);

  const [bankDetailsExist, setBankDetailsExist] = useState([]);

  const [selectedMember, setSelectedMember] = useState([]);

  const {
    clientData,
    loading: clientLoading,
    error: clientError,
  } = useSelector((state) => state.client);

  // console.log("clientData", clientData, bankDetails);


  // Apply all data in one place
  const applyPortfolioData = (data) => {
    setUsers(data?.result3 || []);
    setIsStatesData(data?.statesData || {});
    setSchemeType(data?.schemeType || []);
    setIsEquityDiv(data?.equityDiv || {});
    setIsSIFDiv(data?.sifDiv || {});
    setIsHybridDiv(data?.hybridDiv || {});
    setIsOtherDiv(data?.otherDiv || {});
    setIsDebtDiv(data?.debtDiv || {});
    setIsEquityportfolioData(data?.equityportfolioData || {});
    setIsIndexedPortfolio(data?.indexedPortfolio || {});
    setIsHybridportfolioData(data?.hybridportfolioData || {});
    setIsDebtDivportfolioData(data?.debtportfolioData || {});
    setPortfolioAsset(data?.portfolioAsset || []);
  };
  // Cache key per member
  const getCacheKey = (member) => {
    if (!member) return null;
    // console.log("🚀 Generating cache key", member);

    return `portfolio_${roomId}_${member.groupId}_${member.pan}_${member.pan_client_id || ""}`;
  };


  const fetchInvestmentLivePortfolio = async () => {

    const isHousehold = selectedMember?.pan === "all";
    const allData = isHousehold
      ? { groupId: selectedMember?.groupId, memberId: "", clientid: roomId }
      : { groupId: selectedMember?.groupId, memberId: selectedMember?.wo_id, clientid: roomId }
    console.log("selectedMember1", selectedMember, allData);

    try {
      setIsLoading(true);

      if (socket.connected) {
      socket.emit("message_to", {
        room: roomId,
        data: {
          loading: true,
          selectedMember,
        },
      });
    }
      Swal.fire({
        text: "Please wait...",
        imageUrl: "https://www.finedge.in/assets/images/download.gif",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });


      // const response = await api.post(
      //   `advisor/investmentLivePortfolio`,
      //   allData
      // );
      const response = await api.post(
        `advisor/investmentLivePortfolioWm`,
        allData
      );
      const data = response?.data || {};


      applyPortfolioData(data);
      // SEND DATA VIA SOCKET
      if (socket.connected) {
        socket.emit("message_to", {
          room: roomId,
          data: {
             loading: false,
            selectedMember,
            portfolio: data,
          },
        });
      }

      // setUsers(response?.data?.data?.result3)
      // setIsStatesData(response?.data?.statesData);
      // setSchemeType(response?.data?.schemeType);
      // setIsEquityDiv(response?.data?.equityDiv);
      // setIsHybridDiv(response?.data?.hybridDiv)
      // setIsOtherDiv(response?.data?.otherDiv)
      // setIsDebtDiv(response?.data?.debtDiv)
      // setIsEquityportfolioData(response?.data?.equityportfolioData);
      // setIsIndexedPortfolio(response?.data?.indexedPortfolio)
      // setIsHybridportfolioData(response?.data?.hybridportfolioData)
      // setIsDebtDivportfolioData(response?.data?.debtportfolioData)
      // setPortfolioAsset(response?.data?.portfolioAsset);

      Swal.close();
      setDataStatus({ status: 'success', message: 'Portfolio data fetched successfully.' });

      return data;
    } catch (error) {
      console.error("Error fetching portfolio data:", error);
      setDataStatus({ status: 'error', message: 'Failed to fetch portfolio data.' });
      Swal.close();
      setIsStatesData({});
      setSchemeType([]);
      setIsEquityDiv({});
      setIsSIFDiv({});
      setIsHybridDiv({})
      setIsDebtDiv({})
      setIsOtherDiv({})
      setIsEquityportfolioData({});
      setIsHybridportfolioData({})
      setIsDebtDivportfolioData({})
      setPortfolioAsset([]);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    // console.log("🚀 Calling API 1",selectedMember);

    if (!selectedMember || !selectedMember?.groupId) return;
    // console.log("🚀 Calling API2",selectedMember);


    const cacheKey = getCacheKey(selectedMember);
    const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

    try {
      // console.log("🚀 Calling API2",selectedMember);

      const cached = JSON.parse(localStorage.getItem(cacheKey));
      // console.log("🚀 Calling API3", cached);

      if (cached) {
        const isExpired = Date.now() - cached.timestamp > CACHE_DURATION;
        // console.log("🚀 Calling API4", isExpired);

        if (!isExpired) {
          console.log("✅ Using cached data");
          applyPortfolioData(cached.data);
          // ✅ Emit cached data also
          if (socket.connected) {
            socket.emit("message_to", {
              room: roomId,
              data: {
                 loading: false,
                selectedMember,
                portfolio: cached.data,
              },
            });
          }
          return;
        } else {
          console.log("⏰ Cache expired, removing...");
          localStorage.removeItem(cacheKey);
        }
      }
    } catch (e) {
      console.log("Cache error");
    }

    console.log("🚀 Calling API");

    fetchInvestmentLivePortfolio().then((data) => {
      if (data) {
        const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

        localStorage.setItem(
          cacheKey,
          JSON.stringify({
            data,
            timestamp: Date.now(),
          })
        );
      }
    });
  }, [selectedMember]);

////////////////////////////// Clear old cache when roomId changes
useEffect(() => {
  if (!roomId) return;

  clearOldPortfolioCache(roomId);
}, [roomId]);


  const clearOldPortfolioCache = (currentRoomId) => {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith("portfolio_") && !key.includes(`portfolio_${currentRoomId}_`)) {
      localStorage.removeItem(key);
    }
  });
};
////////////////////////////////////////////////////////////////////
  

  useEffect(() => {
    socket.emit("message", {
      room: roomId,
      data: { subNavRoute, selectedMember, bankDetailsExist },
    });
    console.log("message", { data: { subNavRoute, selectedMember } });
  }, [subNavRoute, selectedMember]);

  const handleNext = () => {
    const nextUrl = `/portfolio-review?clientId=${roomId}`;
    const nextUrl2 = `/portfolio-review`;

    socket.emit("navigate", { room: roomId, url: nextUrl2 });
    navigate(nextUrl);
  };

  const handleBack = () => {
    const prevUrl = `/goal-tracker?clientId=${roomId}`;
    const prevUrl2 = `/goal-tracker`;

    socket.emit("navigate", { room: roomId, url: prevUrl2 });
    navigate(prevUrl);
  };

  const handleTabChange = (tab) => {
    setSubNavRoute(tab);
    setActiveTab(tab);
  };

  // const handleSelectChange = (e) => {
  //   const selectedId = e.target.value;

  //   const selectedData = bankDetailsExist.find(
  //     (member) => member._id === selectedId
  //   );
  //   console.log("selectedData", selectedData, bankDetailsExist, selectedId);
  //   setSelectedMember(selectedData); 
  // };
  const handleSelectChange = (e) => {
    const selectedId = e.target.value;

    if (selectedId === "household") {
      setSelectedMember({
        pan: "all",
        client_name: "Household",
        groupId: bankDetailsExist[0]?.groupId,
      });
      return;
    }
    const selectedData = bankDetailsExist.find(
      (m) => m._id === selectedId
    );

    setSelectedMember(selectedData);
  };

  console.log("selectedMember", bankDetailsExist, selectedMember);

  useEffect(() => {
    getInvestor();
  }, []);

  // Fetch Investor Name fund list from API
  const getInvestor = async () => {
    try {
      const response = await api.get(
        `advisor/gethouseHoldPanInfo/${roomId}`
      );
      const bankDetails = response.data;
      console.log("selectedMember", selectedMember, bankDetails);
      setBankDetailsExist(bankDetails)
      console.log('bankDetails', bankDetails)
      if (bankDetails.length > 0) {

        if (bankDetails.length === 1) {
          setSelectedMember(bankDetails[0]);
        } else {
          setSelectedMember({ pan: "all", client_name: "Household", groupId: bankDetails[0]?.groupId || null });
        }
      } else {
      }
    } catch (error) {
      console.error("Error fetching household PAN info:", error);
      setSelectedMember({ pan: "all", client_name: "Household" });
    }
  };





  return (
    <>
      {bankDetailsExist?.length > 0 &&
        <div className="container">
          <div className="row pb-4 align-items-center">
            {/* Left Side: Label & Dropdown */}
            <div className="col-md-6 col-12 mb-2">
              <label className="fs-14 fw-normal clrlight">
                Live portfolio of
              </label>
              <select
                className="form-select w-50 w-md-25"
                aria-label="Default select example"
                onChange={handleSelectChange}
                value={selectedMember?._id || "household"}
              >
                {
                  !bankDetailsExist?.some((member) => member.type === 'Individual') && (
                    <option value="household">Household</option>
                  )
                }
                {bankDetailsExist?.map((member) => (
                  <option key={member._id} value={member._id}>
                    {member.client_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Right Side: Last Review Date */}
            <div className="col-md-6 col-12 text-md-end text-left mt-md-3 mt-2">
              <p>{clientData?.firstName}</p>
              {clientData?.last_portfolio_review_date &&
                <p className="m-0">
                  Last portfolio review -{" "}
                  {clientData?.last_portfolio_review_date
                    ? new Date(
                      clientData?.last_portfolio_review_date
                    ).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                    : "Not Available"}
                </p>
              }
            </div>
          </div>
        </div>
      }
      <NavTabs activeTab={activeTab} onTabChange={handleTabChange} />

      {!bankDetailsExist?.length > 0 ? <div className="w-75 mx-auto">
        <img
          src="/assets/images/sample-portfolio.png"
          alt="Sample Portfolio Preview"
          className="w-100  object-cover mx-auto"
        />
      </div> :
        <>
          <div className="container minht  pt-3 bggrey">


            {dataStatus?.status === 'error' ?
              (<div className="d-flex flex-column align-items-center justify-content-center py-5 my-5">
                <div
                  className="mb-4"

                >
                  <span style={{ fontSize: '2rem' }}>⚠️</span>
                </div>

                <div className="text-center" style={{ maxWidth: '400px' }}>
                  <h4 className="fw-bold  mb-2 text-danger">
                    {dataStatus.message || "Something went wrong"}
                  </h4>
                  <p className="text-muted mb-4">
                    We couldn't load your portfolio details right now. This might be a temporary connection issue.
                  </p>

                  <button
                    className="btn btn-primary px-4 py-2 rounded-pill shadow-sm"
                    onClick={() => fetchInvestmentLivePortfolio()}
                  >
                    Try Again
                  </button>
                </div>
              </div>)

              : (activeTab === "livePortfolio" && (
                <>

                  {Object.keys(indexedPortfolio || {}).length === 0 &&
                    (!portfolioAsset || portfolioAsset.length === 0) &&
                    (!users || users.length === 0) ? (

                    //             <div className="container">
                    // <div className="row gap-3 ">
                    //               <table className="border p-2 " style={{ borderColor: "#52B58C" }}>

                    //                 <tbody>
                    //                   <tr>
                    //                     <td colspan={2} className="trbgcolor">
                    //                       Grand Total
                    //                     </td>

                    //                     <td className="trbgcolor">
                    //                       <p className="fs-14 mb-0 ">0</p>
                    //                     </td>
                    //                     <td className="trbgcolor">
                    //                       <p className="fs-14 mb-0 ">0</p>
                    //                     </td>
                    //                     <td className="trbgcolor">
                    //                       <p className="fs-14 mb-0 ">0</p>
                    //                     </td>
                    //                     <td className="trbgcolor">
                    //                       <p className="fs-14 mb-0 ">0</p>
                    //                     </td>
                    //                     <td className="trbgcolor">
                    //                       <p className="fs-14 mb-0 ">0</p>
                    //                     </td>
                    //                   </tr>
                    //                 </tbody>
                    //               </table>
                    //               </div>
                    //            </div>

                    <div className="text-center py-5">

                      <h5 className="mt-3"> Data Not Available</h5>
                      <p className="text-muted">
                        Portfolio data not found for the selected member.
                      </p>
                       <button
                    className="btn btn-success px-4 py-2 rounded-pill shadow-sm"
                    onClick={() => fetchInvestmentLivePortfolio()}
                  >
                    Try Again
                  </button>
                    </div>

                  ) : (
                    <PortfolioDetails
                      users={users}
                      isStatesData={isStatesData}
                      isEquityDiv={isEquityDiv}
                        isSIFDiv={isSIFDiv}
                      isDebtDiv={isDebtDiv}
                      isHybridDiv={isHybridDiv}
                      isOtherDiv={isOtherDiv}
                      indexedPortfolio={indexedPortfolio}
                      isEquityportfolioData={isEquityportfolioData}
                      isHybridportfolioData={isHybridportfolioData}
                      isLoading={isLoading}
                      portfolioAsset={portfolioAsset}
                      schemeType={schemeType}
                      isDarkMode={isDarkMode}
                      isDebtDivportfolioData={isDebtDivportfolioData}
                    />
                  )}
                </>

              )
              )
            }

            {activeTab === "systematicInvestments" && (
              <InvestmentsTable
                selectedMember={selectedMember}
                roomId={roomId}
                isLoading={isLoading}
              />
            )}
          </div>
          <div className="row mt-md-3 mt-4">
            <div className="col">
              <div className="container">
                <div className="row my-4">
                  <div className="col text-end">
                    <a href="javascript:void(0);" onClick={handleBack}>
                      <img
                        className="arrow_next1"
                        src="assets/images/left-arrowpng.png"
                        alt=""
                      />
                    </a>
                    <a
                      href="javascript:void(0);"
                      className="ms-1"
                      onClick={handleNext}
                    >
                      <img
                        className="arrow_next"
                        src="assets/images/right-arrow.svg"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </>
  );
};

const NavTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="row">
      {/* Tabs for medium and larger screens */}

      {/* Dropdown for small screens */}
      <div className="col">
        <ul
          className="nav nav-tabs justify-content-center d-flex flex-md-row flex-nowrap"
          id="myTab"
          role="tablist"
        >
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link border-0 navclr ${activeTab === "livePortfolio" ? "active" : ""
                }`}
              type="button"
              role="tab"
              onClick={() => onTabChange("livePortfolio")}
            >
              <span className="fs-21 fw-medium mt-3">Live Portfolio</span>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link border-0 navclr ${activeTab === "systematicInvestments" ? "active" : ""
                }`}
              type="button"
              role="tab"
              onClick={() => onTabChange("systematicInvestments")}
            >
              <span className="fs-21 mt-3">Systematic Investments</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CentredVar;
